<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/pc_banner_sup_accout.webp')">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="main-title">
          本人確認の方法
        </h1>

        <h2 class="subheading fs_6">
          初回の出金申請時にお客様の身分確認が必要となります。 <br>
          お手数ですが、身分証明書と住所確認書類をご提出ください。
        </h2>

        <hr class="hr_line my_5r">

        <h2 class="main-title">
          アカウント設定を行う
        </h2>

        <div class="tab-frame">
          <ul class="tab-list">
            <li class="tab-list-item-account-part1" :class="{'is-btn-active': toggleStates.part1}" @click="toggleState('part1')">
              PC版
            </li>
            <li class="tab-list-item-account-part1" :class="{'is-btn-active': !toggleStates.part1}" @click="toggleState('part1')">
              モバイル版
            </li>
          </ul>

          <h3 class="text-color-primary subheading fs_6">
            ※「アカウント」画面にて必要な情報を入力し登録すると、<br>
            必要な身分証明書類を提出し「アカウント認証」が行えます。
          </h3>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents-account-part1" :class="{'is-contents-active': toggleStates.part1}">
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/account_pc_01.png')" alt="">
              </div>

              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/account_pc_02.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents-account-part1" :class="{'is-contents-active': !toggleStates.part1}">
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/account_mb_01.jpg')" alt="">
              </div>
            </div>
            <!-- モバイル版 tab-contents End -->
          </div>

          <hr class="hr_line my_5r">

          <h3 class="main-title">
            証明用書類
          </h3>

          <h3 class="subheading fs_6 text_left">
            1. 身分証明書用書類として認められるもの：
          </h3>
          <ol class="list-type-disc text-color-primary ff_Mincho">
            <li>運転免許証(裏表)</li>
            <li>パスポート(写真のあるページ)</li>
            <li>住民基本台帳(裏表)</li>
            <li>在留カード</li>
            <li>マイナンバーカード(表)</li>
            <li>特別永住者証明書</li>
          </ol>
          <h3 class="text-color-primary subheading fs_6 text_left">
            ※まず、上記中から1つの証明書と「勝win認証用および提出日当日の日付」と記載した紙と一緒に手で持っていただき、書類およびお顔全体が写るようにセルフィー(自撮り)を撮影ください。またセルフィーは書類両面分撮影ください。
          </h3>

          <div class="img-style-bor-sha">
            <img :src="$getThemeImagePath('sup/account_pc_03.png')" alt="">
          </div>
          <h3 class="subheading fs_6 text_left">
            2. 住所確認書類住所確認用書類として認められるもの：
          </h3>
          <ol class="list-type-disc text-color-primary">
            <li>住民票</li>
            <li>公共料金、携帯電話の請求書</li>
            <li>クレジットカードの請求書</li>
          </ol>
          <h3 class="subheading fs_6 text_left">
            ※手持ちの撮影は不要ですが、「勝win認証用および提出日当日の日付」を記載した紙と一緒に、正面から全体が写るように撮影ください。<br>
            ※住所確認用書類は発行日が3か月以内のもの。<br>
            ※お客様の氏名と住所が一枚の書類上に記載されているもの。<br>
            ※住所確認用書類の四隅がきちんと範囲内に撮影されているもの。<br>
            ※当サイトのアカウント登録時の住所と一致している必要がございます。 書類をアップロードされる前に、ご登録の住所などが最新のものか今一度ご確認ください。
          </h3>
          <div class="img-style-bor-sha">
            <img :src="$getThemeImagePath('sup/account_pc_04.webp')" alt="">
          </div>

          <h3 class="subheading fs_6 text_left">
            注意：携帯電話等のカメラで撮影した画像のみを受け付けます。スキャナで取り込んだ画像や、デジタル化、編集処理されたものは一切認められません。
          </h3>

          <hr class="hr_line my_5r">

          <!-- ファイルのアップロードを行う -->

          <h2 class="main-title">
            ファイルのアップロードを行う
          </h2>

          <ul class="tab-list">
            <li class="tab-list-item" :class="{'is-btn-active': toggleStates.part2}" @click="toggleState('part2')">
              PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': !toggleStates.part2}" @click="toggleState('part2')">
              モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- PC版 -->
            <div class="tab-contents" :class="{'is-contents-active': toggleStates.part2}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「アカウント認証」をクリック
              </h3>

              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/account_pc_05.png')" alt="">
              </div>

              <h1 class="main-title">
                ステップ 2
              </h1>
              <h3 class="text-color-primary text_center subheading fs_6">
                1.アップロードする身分証明書用書類を選択<br>
                2. アップロードする住所確認用書類を選択<br>
                3. その他追加でアップロードが必要な書類を選択
              </h3>

              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/account_pc_06.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>
              <h3 class="text-color-primary text_center subheading fs_6">
                「身分証明用書類」を選んでアップロードする
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/account_pc_07.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 4
              </h3>
              <h3 class="text-color-primary text_center subheading fs_6">
                「住所確認用書類」を選んでアップロードする
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/account_pc_08.png')" alt="">
              </div>
            </div>
            <!-- PC版 tab-contents End -->

            <!-- モバイル版 -->
            <div class="tab-contents" :class="{'is-contents-active': !toggleStates.part2}">
              <h3 class="main-title">
                ステップ 1
              </h3>
              <h3 class="subheading fs_6">
                ホーム画面の「3本線アイコン」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/account_mb_02.jpg')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 2
              </h3>
              <h3 class="subheading fs_6">
                アカウントをプルダウンし「アカウント認証」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/account_mb_03.png')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 3
              </h3>
              <h3 class="text-color-primary text_center subheading fs_6">
                1.アップロードする身分証明書用書類を選択<br>
                2. アップロードする住所確認用書類を選択<br>
                3. その他追加でアップロードが必要な書類を選択
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/account_mb_03.jpg')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 4
              </h3>
              <h3 class="subheading fs_6">
                「身分証明用書類」を選んでアップロードする
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/account_mb_04.jpg')" alt="">
              </div>

              <h3 class="main-title">
                ステップ 5
              </h3>
              <h3 class="subheading fs_6">
                「住所確認用書類」を選んでアップロードする
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/account_mb_05.jpg')" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      toggleStates: {
        part1: true,
        part2: true
      }
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'account-verification',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    toggleState(key) {
      if (this.toggleStates.hasOwnProperty(key)) {
        this.toggleStates[key] = !this.toggleStates[key]
      }
    }
  }
}
</script>
